import React, {Component} from "react";

import "./home-player-dashboard.css";



class HomePlayerGameSessionCard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false
        };
    }

    onClick() {
        let {on_click, session, selected_session} = this.props;


        if (selected_session) {
            return;
        }

        on_click(session.game_session_id);
    }

    render() {
        let {session, session_selected} = this.props;

        let freePlayClass = "";

        if (session.game_session_id === -1) {
            freePlayClass = "free_play"
           
        }
        
        let cardClass = "home_player_dashboard_session_card " + freePlayClass;

        let showLoading = false;
        if (session_selected && session_selected === session.game_session_id) {
            showLoading = true;
        }

        return (
            <div className={cardClass} onClick={this.onClick.bind(this)}>
    <div>{session.name}</div>
    {showLoading && <span className='home_play_session_loading'>Loading... <i className='fa fa-spin fa-spinner'></i></span>}                
            </div>            
        )
    }
}

export default HomePlayerGameSessionCard;


// WEBPACK FOOTER //
// ./src/components/containers/home-player-dashboard/home-player-game-session-card.js